export default __webpack_public_path__ + "static/Dr. Osama al-Fayoumi-a4ad7ab77ed9ee664f347b69072aa741.jpeg";